import { FC } from "react";

import {
    StyledIgnoreStockButton,
    StyledIgnoreStockWrapper,
} from "./IgnoreStockActions.styled";

interface Props {
    onIgnoreClick: () => void;
}

export const IgnoreStockActions: FC<Props> = ({ onIgnoreClick }) => {
    return (
        <StyledIgnoreStockWrapper>
            <StyledIgnoreStockButton type="primary" onClick={onIgnoreClick}>
                Ігнорувати залишки
            </StyledIgnoreStockButton>
        </StyledIgnoreStockWrapper>
    );
};
